import type { ICRMEventsContext } from '@fhs-legacy/frontend/src/state/crm-events';
import {
  ClickEventComponentNames,
  CustomEventNames,
  EventTypes,
} from '@fhs-legacy/frontend/src/state/crm-events/constants';

export const logGiftCardsPageView = (logRBIEvent: ICRMEventsContext['logRBIEvent']) => {
  logRBIEvent({
    name: CustomEventNames.PAGE_VIEW,
    type: EventTypes.Other,
    attributes: {
      pathname: '/account/gift-cards',
      path: '/account/gift-cards',
      text: 'Gift Cards Page View',
    },
  });
};

export const logAddGiftCardPress = (logRBIEvent: ICRMEventsContext['logRBIEvent']) => {
  logRBIEvent({
    name: CustomEventNames.CLICK_EVENT,
    type: EventTypes.Other,
    attributes: {
      component: ClickEventComponentNames.BUTTON,
      text: 'Add Gift Card',
      payment_version: 'fresh',
    },
  });
};

export const logCheckBalancePress = (logRBIEvent: ICRMEventsContext['logRBIEvent']) => {
  logRBIEvent({
    name: CustomEventNames.CLICK_EVENT,
    type: EventTypes.Other,
    attributes: {
      component: ClickEventComponentNames.BUTTON,
      text: 'Check Balance',
      payment_version: 'fresh',
    },
  });
};

export const logTransactionHistoryPress = (logRBIEvent: ICRMEventsContext['logRBIEvent']) => {
  logRBIEvent({
    name: CustomEventNames.CLICK_EVENT,
    type: EventTypes.Other,
    attributes: {
      component: ClickEventComponentNames.BUTTON,
      text: 'Transaction History',
      payment_version: 'fresh',
    },
  });
};

export const logViewDigitalGiftCardPress = (logRBIEvent: ICRMEventsContext['logRBIEvent']) => {
  logRBIEvent({
    name: CustomEventNames.CLICK_EVENT,
    type: EventTypes.Other,
    attributes: {
      component: ClickEventComponentNames.BUTTON,
      text: 'View Digital Gift Card',
      payment_version: 'fresh',
    },
  });
};

export const logGiftCardContinuePress = (
  logRBIEvent: ICRMEventsContext['logRBIEvent'],
  flow: 'Add Gift Card' | 'Check Balance'
) => {
  logRBIEvent({
    name: CustomEventNames.CLICK_EVENT,
    type: EventTypes.Other,
    attributes: {
      component: ClickEventComponentNames.BUTTON,
      text: 'Continue',
      flow,
      payment_version: 'fresh',
    },
  });
};

export const logDismissActionSheet = (
  logRBIEvent: ICRMEventsContext['logRBIEvent'],
  flow: 'Add Gift Card' | 'Check Balance',
  step: string
) => {
  logRBIEvent({
    name: CustomEventNames.ACTION_SHEET_SUBMISSION,
    type: EventTypes.Other,
    attributes: {
      state: 'dismiss',
      flow,
      step,
      payment_version: 'fresh',
    },
  });
};

export function logGiftCardApiResponse(
  logRBIEvent: ICRMEventsContext['logRBIEvent'],
  flow: 'Add Gift Card' | 'Check Balance' | 'Reload Gift Card',
  result: 'success',
  apiResult: Record<string, string | number>
): void;
export function logGiftCardApiResponse(
  logRBIEvent: ICRMEventsContext['logRBIEvent'],
  flow: 'Add Gift Card' | 'Check Balance' | 'Reload Gift Card',
  result: 'failure',
  errorMessage: string
): void;
export function logGiftCardApiResponse(
  logRBIEvent: ICRMEventsContext['logRBIEvent'],
  flow: 'Add Gift Card' | 'Check Balance' | 'Reload Gift Card',
  result: 'success' | 'failure',
  errorMessageOrApiResult: string | Record<string, string | number>
): void {
  let attributes: Record<string, string | number> = {
    flow,
    result,
    payment_version: 'fresh',
  };

  if (
    result === 'success' &&
    errorMessageOrApiResult != null &&
    typeof errorMessageOrApiResult === 'object'
  ) {
    attributes = { ...attributes, ...(errorMessageOrApiResult as Record<string, string | number>) };
  }

  if (result === 'failure' && typeof errorMessageOrApiResult === 'string') {
    attributes.errorMessage = errorMessageOrApiResult;
  }

  logRBIEvent({
    name: CustomEventNames.GIFT_CARD_EVENT,
    type: EventTypes.Other,
    attributes,
  });
}
